import React, { useEffect } from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import ContactForm from '@/components/ContactForm';
import { initScrollReveal } from '@/utils/scrollReveal';
import { useTranslation } from 'react-i18next';
import Seo from '@/components/Seo';

/**
 * Landing page for Facebook (and other) ads: form-only view with nav so users
 * can submit a request immediately or browse the rest of the site.
 * Uses the same ContactForm → Kommo integration as the main contact section.
 */
const RequestQuote = () => {
  const { t } = useTranslation('request-quote');

  useEffect(() => {
    const cleanup = initScrollReveal();
    return cleanup;
  }, []);

  return (
    <div className="relative overflow-x-hidden min-h-screen flex flex-col">
      <Seo page="request-quote" />
      <Navbar />

      <main className="flex-1">
        <section className="pt-28 pb-16 md:pt-32 md:pb-20 bg-gradient-to-b from-dental-light/10 via-dental-light/5 to-dental-mint/5 relative overflow-hidden">
          {/* Soft top gradient */}
          <div className="absolute top-0 left-0 w-full h-24 bg-gradient-to-b from-white/80 to-transparent pointer-events-none" />
          {/* Themed blur orbs – same palette as rest of site */}
          <div className="absolute top-20 right-0 w-96 h-96 bg-dental-mint/15 rounded-full blur-3xl pointer-events-none" />
          <div className="absolute bottom-20 left-0 w-80 h-80 bg-dental/15 rounded-full blur-3xl pointer-events-none" />
          <div className="absolute top-1/2 -left-20 w-64 h-64 bg-dental-coral/10 rounded-full blur-3xl pointer-events-none" />
          <div className="absolute bottom-0 right-1/4 w-72 h-72 bg-dental-tertiary/10 rounded-full blur-3xl pointer-events-none" />

          <div className="container mx-auto px-4 relative z-10">
            <div className="max-w-2xl mx-auto text-center mb-10 reveal" data-direction="up">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-display font-bold mb-6 text-gradient-primary">
                {t('hero.title')}
              </h1>
              <p className="mt-3 text-lg text-dental-dark/80">
                {t('hero.description')}
              </p>
            </div>

            <div className="max-w-xl mx-auto reveal" data-direction="up">
              <ContactForm title={t('form.title')} />
            </div>

            <p className="text-center mt-6 text-sm text-dental-dark/60">
              {t('call.prefix')}{' '}
              <a href="tel:+359879800430" className="text-dental font-medium hover:underline">
                +359 879 800 430
              </a>
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default RequestQuote;
